import React from 'react';
import {
    // Навигация и UI
    ChevronUpIcon, PlusIcon, MinusIcon, HomeIcon, CrosshairIcon,
    SearchIcon, FilterIcon, CloseIcon, MenuIcon, CopyIcon,
    ExternalLinkIcon, GlobeIcon,
    // Объекты на карте
    BuildingIcon, OfficeIcon, HouseIcon, FactoryIcon, LandmarkIcon,
    PinIcon, RoadIcon, RailroadIcon, BoundaryIcon, WaterIcon,
    ForestIcon, ParkIcon,
    // Инструменты редактирования
    MoveIcon, RotateIcon, ScaleIcon, DrawPolygonIcon, DrawLineIcon,
    DrawPointIcon, MergeIcon, SplitIcon, UndoRedoIcon, RulerIcon,
    LayersIcon,
    // Статусы и состояния
    ForSaleIcon, UnderConstructionIcon, PlannedIcon, CheckCircleIcon,
    AlertTriangleIcon, XCircleIcon
} from '../Icon';

const IconShowcase = () => {
    const iconCategories = [
        {
            title: 'Навигация и UI',
            icons: [
                { name: 'ChevronUpIcon', component: ChevronUpIcon },
                { name: 'PlusIcon', component: PlusIcon },
                { name: 'MinusIcon', component: MinusIcon },
                { name: 'HomeIcon', component: HomeIcon },
                { name: 'CrosshairIcon', component: CrosshairIcon },
                { name: 'SearchIcon', component: SearchIcon },
                { name: 'FilterIcon', component: FilterIcon },
                { name: 'CloseIcon', component: CloseIcon },
                { name: 'MenuIcon', component: MenuIcon },
                { name: 'CopyIcon', component: CopyIcon },
                { name: 'ExternalLinkIcon', component: ExternalLinkIcon },
                { name: 'GlobeIcon', component: GlobeIcon },
            ]
        },
        {
            title: 'Объекты на карте',
            icons: [
                { name: 'BuildingIcon', component: BuildingIcon },
                { name: 'OfficeIcon', component: OfficeIcon },
                { name: 'HouseIcon', component: HouseIcon },
                { name: 'FactoryIcon', component: FactoryIcon },
                { name: 'LandmarkIcon', component: LandmarkIcon },
                { name: 'PinIcon', component: PinIcon },
                { name: 'RoadIcon', component: RoadIcon },
                { name: 'RailroadIcon', component: RailroadIcon },
                { name: 'BoundaryIcon', component: BoundaryIcon },
                { name: 'WaterIcon', component: WaterIcon },
                { name: 'ForestIcon', component: ForestIcon },
                { name: 'ParkIcon', component: ParkIcon },
            ]
        },
        {
            title: 'Инструменты редактирования',
            icons: [
                { name: 'MoveIcon', component: MoveIcon },
                { name: 'RotateIcon', component: RotateIcon },
                { name: 'ScaleIcon', component: ScaleIcon },
                { name: 'DrawPolygonIcon', component: DrawPolygonIcon },
                { name: 'DrawLineIcon', component: DrawLineIcon },
                { name: 'DrawPointIcon', component: DrawPointIcon },
                { name: 'MergeIcon', component: MergeIcon },
                { name: 'SplitIcon', component: SplitIcon },
                { name: 'UndoRedoIcon', component: UndoRedoIcon },
                { name: 'RulerIcon', component: RulerIcon },
                { name: 'LayersIcon', component: LayersIcon },
            ]
        },
        {
            title: 'Статусы и состояния',
            icons: [
                { name: 'ForSaleIcon', component: ForSaleIcon },
                { name: 'UnderConstructionIcon', component: UnderConstructionIcon },
                { name: 'PlannedIcon', component: PlannedIcon },
                { name: 'CheckCircleIcon', component: CheckCircleIcon },
                { name: 'AlertTriangleIcon', component: AlertTriangleIcon },
                { name: 'XCircleIcon', component: XCircleIcon },
            ]
        }
    ];

    return (
        <div style={{ padding: 'var(--spacing-xl)', maxWidth: '1400px', margin: '0 auto' }}>
            <h1 style={{ marginBottom: 'var(--spacing-lg)' }}>Библиотека иконок</h1>
            <p style={{ marginBottom: 'var(--spacing-xl)', color: 'var(--text-secondary)' }}>
                Всего иконок: {iconCategories.reduce((sum, cat) => sum + cat.icons.length, 0)}
            </p>

            {iconCategories.map((category, categoryIndex) => (
                <section key={categoryIndex} style={{ marginBottom: 'var(--spacing-xxl)' }}>
                    <h2 style={{ 
                        fontSize: 'var(--font-size-xl)', 
                        fontWeight: 'var(--font-weight-semibold)',
                        marginBottom: 'var(--spacing-lg)',
                        paddingBottom: 'var(--spacing-sm)',
                        borderBottom: '2px solid var(--border-color)'
                    }}>
                        {category.title}
                    </h2>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                        gap: 'var(--spacing-md)'
                    }}>
                        {category.icons.map((iconItem, iconIndex) => {
                            const IconComponent = iconItem.component;
                            return (
                                <div
                                    key={iconIndex}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        padding: 'var(--spacing-md)',
                                        border: '1px solid var(--border-color)',
                                        borderRadius: 'var(--border-radius-md)',
                                        backgroundColor: 'var(--bg-secondary)',
                                        transition: 'all 0.2s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '60px',
                                        height: '60px',
                                        marginBottom: 'var(--spacing-sm)',
                                        backgroundColor: 'var(--bg-primary)',
                                        borderRadius: 'var(--border-radius-sm)'
                                    }}>
                                        <IconComponent size={32} strokeWidth={1.5} />
                                    </div>
                                    <code style={{
                                        fontSize: 'var(--font-size-sm)',
                                        color: 'var(--text-primary)',
                                        textAlign: 'center',
                                        wordBreak: 'break-all'
                                    }}>
                                        {iconItem.name}
                                    </code>
                                </div>
                            );
                        })}
                    </div>
                </section>
            ))}

            <section style={{ marginTop: 'var(--spacing-xxl)' }}>
                <h2 style={{ 
                    fontSize: 'var(--font-size-xl)', 
                    fontWeight: 'var(--font-weight-semibold)',
                    marginBottom: 'var(--spacing-lg)'
                }}>
                    Примеры использования
                </h2>
                <div style={{ 
                    backgroundColor: 'var(--bg-secondary)',
                    padding: 'var(--spacing-lg)',
                    borderRadius: 'var(--border-radius-md)',
                    border: '1px solid var(--border-color)'
                }}>
                    <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Разные размеры</h3>
                    <div style={{ display: 'flex', gap: 'var(--spacing-lg)', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{ textAlign: 'center' }}>
                            <PlusIcon size={16} />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>16px</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <PlusIcon size={20} />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>20px</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <PlusIcon size={24} />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>24px</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <PlusIcon size={32} />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>32px</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <PlusIcon size={48} />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>48px</div>
                        </div>
                    </div>

                    <h3 style={{ marginTop: 'var(--spacing-lg)', marginBottom: 'var(--spacing-md)' }}>Разная толщина обводки</h3>
                    <div style={{ display: 'flex', gap: 'var(--spacing-lg)', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{ textAlign: 'center' }}>
                            <SearchIcon size={32} strokeWidth={1} />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>1</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <SearchIcon size={32} strokeWidth={1.5} />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>1.5</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <SearchIcon size={32} strokeWidth={2} />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>2</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <SearchIcon size={32} strokeWidth={2.5} />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>2.5</div>
                        </div>
                    </div>

                    <h3 style={{ marginTop: 'var(--spacing-lg)', marginBottom: 'var(--spacing-md)' }}>Разные цвета</h3>
                    <div style={{ display: 'flex', gap: 'var(--spacing-lg)', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{ textAlign: 'center' }}>
                            <HomeIcon size={32} color="#007bff" />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>Blue</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <HomeIcon size={32} color="#28a745" />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>Green</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <HomeIcon size={32} color="#dc3545" />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>Red</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <HomeIcon size={32} color="#ffc107" />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>Yellow</div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <HomeIcon size={32} color="#6c757d" />
                            <div style={{ fontSize: 'var(--font-size-xs)', marginTop: '4px' }}>Gray</div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default IconShowcase;